import * as yup from 'yup';

export const adGroupsFormValidationSchema = (t: any) => yup.object({
  name: yup
    .string()
    .matches(/^[A-Za-z0-9\x80-\xFF_\- ]+$/, t('nameOnlyContainLetters'))
    .required(t('inputIsRequired')),
  campaignId: yup
    .number()
    .required(),
  adGroupCode: yup
    .string()
    .nullable()
    .matches(
      /^[A-Za-z0-9_\-]+$/,
      t('nameIsCode'),
    ),
});
